import React, { FC } from 'react';
import { getLanguage } from '~/utils/language';
import Constants from '~/app/Constants';
import logoHyundaiFr from '~/stories/assets/hyundai/Logo_FR.svg';
import logoHyundaiEn from '~/stories/assets/hyundai/Logo_EN.svg';
import logoGenesisFr from '~/stories/assets/genesis/Logo_FR.svg';
import logoGenesisEn from '~/stories/assets/genesis/Logo_EN.svg';

import {
  StyledContainer, StyledCliplogo, StyledLegalNoticeParagraph,
} from './FooterWithLogo.styles';

interface FooterWithLogoProps {
  copyrightText: string;
  dealerExperience: string;
}

function GetLogo(exp: string) {
  if (getLanguage() === 'en') {
    switch (exp) {
      case Constants.DealersExperience.hyundai:
        return logoHyundaiEn;
      case Constants.DealersExperience.genesis:
        return logoGenesisEn;
      default:
        return '';
    }
  } else {
    switch (exp) {
      case Constants.DealersExperience.hyundai:
        return logoHyundaiFr;
      case Constants.DealersExperience.genesis:
        return logoGenesisFr;
      default:
        return '';
    }
  }
}

const FooterWithLogo: FC<FooterWithLogoProps> = ({ copyrightText, dealerExperience }) => {
  const logo = GetLogo(dealerExperience);
  return (
    <>
      {dealerExperience === Constants.DealersExperience.hyundai || dealerExperience === Constants.DealersExperience.genesis ? (
        <>
          <StyledContainer>
            <StyledCliplogo data-testid="logo" src={logo} experience={dealerExperience} />
          </StyledContainer>
          <StyledLegalNoticeParagraph id="legalNoticeParagraph" data-testid="testwithlogo" withLogo>
            {copyrightText}
          </StyledLegalNoticeParagraph>
        </>
      ) : null}
      {dealerExperience === Constants.DealersExperience.unifi || dealerExperience === Constants.DealersExperience.honda || dealerExperience === Constants.DealersExperience.acura ? (
        <StyledLegalNoticeParagraph id="legalNoticeParagraph" data-testid="testwithoutlogo" withLogo={false}>
          {copyrightText}
        </StyledLegalNoticeParagraph>
      ) : null}
    </>
  );
};
export default FooterWithLogo;
